import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";

// Fix default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Pin "perdu" : goutte orange (harmonisé avec MapOverview)
const lostPin = L.divIcon({
  className: "",
  html: `<div style="filter: drop-shadow(0 4px 8px rgba(249,115,22,.45));"><svg width="38" height="46" viewBox="0 0 38 46" xmlns="http://www.w3.org/2000/svg"><path d="M19 46c-6-6-15-13-15-24a15 15 0 1 1 30 0c0 11-9 18-15 24z" fill="#f97316"/><circle cx="19" cy="17" r="4.5" fill="#ffffff"/></svg></div>`,
  iconSize: [38, 46], iconAnchor: [19, 46],
});
// Pin "trouvé" : goutte rose
const foundPin = L.divIcon({
  className: "",
  html: `<div style="filter: drop-shadow(0 4px 8px rgba(244,63,94,.45));"><svg width="38" height="46" viewBox="0 0 38 46" xmlns="http://www.w3.org/2000/svg"><path d="M19 46c-6-6-15-13-15-24a15 15 0 1 1 30 0c0 11-9 18-15 24z" fill="#f43f5e"/><circle cx="19" cy="17" r="4.5" fill="#ffffff"/></svg></div>`,
  iconSize: [38, 46], iconAnchor: [19, 46],
});
const bunnyIcon = lostPin; // backward compat (default = orange pin)

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) { onPick(e.latlng); },
  });
  return null;
}

function Recenter({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) map.setView(position, 13);
  }, [position, map]);
  return null;
}

export default function MapPicker({ value, onChange, height = 360, readOnly = false, initialCenter = [46.6, 2.5], initialZoom = 5, pinType = "lost", centerOn = null }) {
  const [pos, setPos] = useState(value || null);

  useEffect(() => { if (value) setPos(value); }, [value]);

  const handlePick = (latlng) => {
    if (readOnly) return;
    setPos(latlng);
    onChange && onChange({ lat: latlng.lat, lng: latlng.lng });
  };

  const icon = pinType === "found" ? foundPin : lostPin;

  return (
    <div className="rounded-3xl overflow-hidden border-4 border-white shadow-[0_8px_30px_rgba(244,63,94,0.12)]" data-testid="map-picker">
      <MapContainer
        center={pos ? [pos.lat, pos.lng] : initialCenter}
        zoom={pos ? 13 : initialZoom}
        style={{ height: `${height}px`, width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {!readOnly && <ClickHandler onPick={handlePick} />}
        {pos && <Marker position={[pos.lat, pos.lng]} icon={icon} />}
        {pos && <Recenter position={[pos.lat, pos.lng]} />}
        {!pos && centerOn && <Recenter position={[centerOn.lat, centerOn.lng]} />}
      </MapContainer>
      {!readOnly && (
        <div className="bg-rose-50/70 text-sm text-stone-600 px-4 py-2">
          {pos ? `📍 Position sélectionnée : ${pos.lat.toFixed(4)}, ${pos.lng.toFixed(4)}` : "Cliquez sur la carte pour placer un point"}
        </div>
      )}
    </div>
  );
}
